import { DataBean } from "../DataBean";

export class IncomeCompensationDocument extends DataBean {


    // public async getIncomeCompensationDocumentCatalog(IDDocument:any,DocumentDate:any): Promise<any> {
    //     return this.getCustomService("QuickDataERPCore", "java.util.List_getIncomeCompensationDocumentCatalog_Number_java.util.Date", [IDDocument,DocumentDate]);
    // }
    public async getIncomeCompensationDocumentCatalog(IDDocument: any, DocumentDate: any, documentState: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getIncomeCompensationDocumentCatalog_Number_java.util.Date_Number_String_Number_Number", [IDDocument, DocumentDate, documentState, regexStr, page, recordsPerPage]);
    }
    public async getPaymentHeaderCredit(page:number,rows:number,props:any,year:number): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getPaymentHeaderCredit_Number_Number_java.util.Map_Number",
             [page,rows,props,year]);
    }
    

}